module.exports = __webpack_public_path__ + "img/image 4.72602f14.png";